import { wholeTicks } from '../effects';
import type { SpecialModule } from '../specials/types';

export const beatArmor: SpecialModule = ({ state, tempo }, enemy, effect) => {
  if (effect.kind !== 'beatArmor') {
    return;
  }
  const intoCycle = state.tick % wholeTicks(effect.cycleBeats * tempo.ticksPerBeat);
  const open = intoCycle < wholeTicks(effect.openBeats * tempo.ticksPerBeat);
  if (enemy.armor === undefined) {
    enemy.armor = { damageMul: effect.offBeatMul, open };
  } else {
    enemy.armor.open = open;
  }
};
